<template>
  <div ref="madeForm">
    <avue-form :option="optionForm" ref="form" v-model="formData"></avue-form>
    <span slot="dialog_footer" class="dialog-footer">
      <el-button icon="el-icon-circle-plus-outline" type="primary" @click="submitForm()" :disabled="loading">提交</el-button>
      <el-button icon="el-icon-circle-close" @click="$emit('handleClose')" :disabled="loading">取消</el-button>
    </span>
  </div>
</template>

<script>
import { alarmHandling, batchAlarmHandling, oneClickAlarmHandling } from "../api";

export default {
  props: {
    transmitData: {
      required: true,
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data () {
    return {
      loading: false,
      formData: {},
      optionForm: {
        ...this.$store.state.formOption,
        submitBtn: false,
        emptyBtn: false,
        labelWidth: 150,
        span: 12,
        column: [
          {
            label: "处理结果",
            prop: "processResult",
            type: "textarea",
            maxlength: 200,
            showWordLimit: true,
            span: 24,
            minRows: 3,
            overHidden: true,
          },
          {
            label: "报警状态",
            prop: "alertStatus",
            type: 'select',
            overHidden: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=alert_status",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            value: 3
          },
          {
            label: "备注",
            prop: "remark",
            type: "textarea",
            maxlength: 200,
            showWordLimit: true,
            span: 24,
            minRows: 3,
            overHidden: true,
          },
        ]
      },
    }
  },
  methods: {
    submitForm () {
      const { type, id, ids, query } = this.transmitData
      const payload = { ...this.formData }
      let request
      if (type === 'batch') {
        request = batchAlarmHandling(ids, payload)
      } else if (type === 'oneClick') {
        request = oneClickAlarmHandling({
          query,
          handling: payload
        })
      } else {
        request = alarmHandling({
          ...payload,
          id
        })
      }
      this.loading = true
      request.then(({data}) => {
        if (data.code === 200) {
          this.$message.success(data.msg)
          this.$emit('handleClose')
        } else {
          this.$message.error(data.msg || '处理失败')
        }
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>
